import { FC } from "react";
import { TeamContext } from "../../../types/common";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { Header } from "../../../components/layout";
import { AcademyBranches } from "../../../widgets/mainScreen/AcademyBranches";
import { Timeline } from "./Timeline";
import { TicketsStoryWidget } from "../../../widgets/mainScreen/TicketsStory";

export const TeamHeader: FC = () => {
    const config = useConfiguration();

    let teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА»";
    let linkUrl = "/";
    if (config.teamName === TeamContext.ACADEMY) {
        teamTitle = "АКАДЕМИЯ «РОДИНА»";
    } else if (config.teamName === TeamContext.RODINA_2) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА-2»";
        linkUrl = "/2/";
    } else if (config.teamName === TeamContext.RODINA_3) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА-3»";
        linkUrl = "/3/";
    } else if (config.teamName === TeamContext.RODINA_M) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА» Молодёжка";
        linkUrl = "/youth/";
    } else if (config.teamName === TeamContext.RODINA) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА»";
    }

    if (config.teamName !== TeamContext.ACADEMY) {
        return null;
    }

    let rightSideElements = null;

    if (config.teamName === TeamContext.ACADEMY) {
        rightSideElements = (
            <AcademyBranches />
        );
    }

    return (
        <>
            <Header
                clubTitle={teamTitle}
                onLogoClick={() => window.location.assign(linkUrl)}
                rightSideElements={rightSideElements}
            />
        </>
    );
}